"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcDropdownToggle_1 = require("./AcDropdownToggle");
exports.AcDropdown = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'AcDropdown' : _b, toggle = _a.toggle, toggleClassName = _a.toggleClassName, menuStyle = _a.menuStyle, menuClassName = _a.menuClassName, alignRight = _a.alignRight, children = _a.children;
    return (react_1.default.createElement(react_bootstrap_1.Dropdown, null,
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { as: AcDropdownToggle_1.AcDropdownToggle, id: id, className: toggleClassName }, toggle),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { alignRight: alignRight, style: __assign({ minWidth: '14rem' }, menuStyle), className: menuClassName }, children)));
};
exports.AcDropdown.displayName = 'AcDropdown';
//# sourceMappingURL=AcDropdown.js.map